import { Action } from '../action';
import { AuthType } from '../Auth/action';
import { RedirectState } from './state';
import { RedirectType } from './action';

export const initialState: RedirectState = {
    url: null,
};

export const redirectReducer = (state: RedirectState | undefined, action: Action): RedirectState => {
    state = state ?? initialState;

    switch (action.type) {
        case RedirectType.RedirectRequested:
            return { ...state, url: action.url };
        case AuthType.TokenExpired:
        case RedirectType.RedirectPerformed:
            return initialState;
        default:
            return state;
    }
};
